import React from "react";
import { BsLinkedin, BsGithub, BsBehance, BsInstagram } from "react-icons/bs";

function SocialLinks() {
  return (
    <div className="app__social">
      <div>
        <a
          href="https://www.linkedin.com/in/thiago-santos-966064187/"
          target="_blank"
        >
          <BsLinkedin />
        </a>
      </div>
      <div>
        <a href="https://github.com/ThiagoSantosTh" target="_blank">
          <BsGithub />
        </a>
      </div>
      <div>
        <a href="https://www.behance.net/thiagosantos231" target="_blank">
          <BsBehance />
        </a>
      </div>
      <div>
        <a href="https://www.instagram.com/thiago.santosth_/" target="_blank">
          <BsInstagram />
        </a>
      </div>
    </div>
  );
}

export default SocialLinks;
